// scheduling/components/OnSiteFilterNote.jsx
// "This candidate list is restricted to the on-site job's office" note.
//
// WHY THIS EXISTS
// ---------------
// Four surfaces hard-filter ranked suggestions to the job's office when the job carries
// the on-site flag, and until now only two of them said so:
//   * Staff Suggestions page  -- said so, with a toggle
//   * grid quick-suggest      -- said so, but with no explanation of what it meant
//   * schedule chooser        -- silently filtered
//   * conflict resolution     -- silently filtered, AND fell through to "No candidates
//                                at a similar level with capacity this week", which
//                                names the wrong reason entirely
// A silent filter is worse than no filter: the list is short, the explanation is absent,
// and the obvious conclusion ("nobody is available") is false.
//
// The filter stays HARD here by decision -- no toggle. To reach an out-of-office
// staffer, use the surface's own search box, which is deliberately not filtered and
// badges the mismatch instead (see OffOfficeFlag).

/**
 * @param {boolean} isOnSite      is the job flagged on-site?
 * @param {string} officeCode     the job's OfficeCode (what the list is filtered to)
 * @param {string} office         the job's full office name, for the tooltip
 * @param {string} className      container class, so each surface keeps its own layout
 */
export default function OnSiteFilterNote({ isOnSite, officeCode, office, className = '', style }) {
  if (!isOnSite || !officeCode) return null;

  return (
    <span
      className={`sched-onsite-note ${className}`.trim()}
      title={
        `This job is flagged on-site in ${office || officeCode}, so the suggestions below `
        + `only include staff based in ${officeCode}. That is why the list may be short. `
        + `To pick someone from another office, use the search box — it is not filtered, `
        + `and it flags anyone who would have to travel.`
      }
      style={style}
    >
      &#128205; on-site: {officeCode} only
    </span>
  );
}
